export default "__VITE_ASSET__BN4rr6SE__"